import { Injectable } from '@angular/core';
import { DateFormatterParams, CalendarMomentDateFormatter } from 'angular-calendar';


@Injectable()
export class CustomDateFormatter extends CalendarMomentDateFormatter {

  public monthViewColumnHeader({ date, locale }: DateFormatterParams): string {
    return this.moment(date)
      .locale(locale)
      .format('dd').slice(0, 1);
  }

  public dayViewHour({ date, locale }: DateFormatterParams): string {
    return this.moment(date)
      .locale(locale)
      .format('HH:mm');
  }

  public weekViewHour({ date, locale }: DateFormatterParams): string {
    return this.moment(date)
      .locale(locale)
      .format('HH:mm');
  }

  public weekViewColumnSubHeader({ date, locale }: DateFormatterParams): string {
    return this.moment(date)
      .locale(locale)
      .format('D MMM');
  }

}
